import {CustomInvoiceAdapter} from './custom-invoice.adapter';
import {B2BDocumentTypeList, InvoiceHistoryList, InvoicesFilter} from '../invoices.model';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CustomInvoiceConnector {
  constructor(protected adapter: CustomInvoiceAdapter) {
  }

  public get(
    userId: string,
    pageSize: number,
    currentPage: number,
    sort: string,
    invoicesFilter: InvoicesFilter): Observable<InvoiceHistoryList> {
    return this.adapter.loadHistory(userId, pageSize, currentPage, sort, invoicesFilter);
  }

  public getDocumentTypes(): Observable<B2BDocumentTypeList> {
    return this.adapter.loadDocumentTypes();
  }

}
